import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { ApproveBatchParticipationPaymentBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const approveBatchPayment = createApiThunk<void, ApproveBatchParticipationPaymentBody>(
  "batchPayments/approveBatchPayment",
  async (data, { extra: { adminRepository } }) => {
    return adminRepository!.approvePayment(data);
  },
);

export const resetApproveBatchPayment = createAction("batchPayments/resetApproveBatchPayment");
